"use strict";

exports.__esModule = true;
exports.wildcardToRegExp = exports.wildcardSearch = exports.safeMatch = exports["default"] = exports.cacheReg = void 0;
var _reshowConstant = require("reshow-constant");
//@ts-check

var esc = /[|\\{}()[\]^$+*?.]/g;
var pathEscReg = /[|{}()^$+]/g;
var bracketsEscReg = /[|\\{}()[\]^$+.]/g;

/**
 * @param {any} txt
 * @returns {string}
 */
var text = function text(txt) {
  return txt ? txt + "" : "";
};

/**
 * @param {string} regString
 */
var getSafeReg = function getSafeReg(regString) {
  return text(regString).replace(esc, "\\$&");
};

/**
 * @param {object} cache
 */
var cacheReg = function cacheReg(cache) {
  return (
    /**
     * @param {CallableFunction} [getRegCallback]
     * @param {string} [flags]
     */
    function (getRegCallback, flags) {
      return (
        /**
         * @param {string} regString
         * @returns {RegExp}
         */
        function (regString) {
          if (!cache[regString]) {
            var cookRegString = getRegCallback ? getRegCallback(regString) : regString;
            cache[regString] = new RegExp(cookRegString, flags);
          }
          return cache[regString];
        }
      );
    }
  );
};

/**
 * @param {string} testText
 * @param {RegExp} reg
 * @returns {RegExpMatchArray|null}
 */
exports.cacheReg = cacheReg;
var safeMatch = function safeMatch(testText, reg) {
  return text(testText).match(reg);
};

/**
 * @typedef {object} RegInput
 * @property {RegExp} reg
 * @property {string[]} keys
 */

/**
 * @typedef {object} wildcardToRegExpOptional
 * @property {('bracketsEsc'|'')} [type=null]
 */
exports.safeMatch = safeMatch;
var pathCache = {
  "": (0, _reshowConstant.NEW_OBJ)(),
  bracketsEsc: (0, _reshowConstant.NEW_OBJ)()
};
/**
 * Normalize the given path string,
 * returning a regular expression.
 *
 * An empty array should be passed,
 * which will contain the placeholder
 * key names.
 * For example "/user/:id" will contain ["id"].
 *
 * @param  {string} path
 * @param  {wildcardToRegExpOptional} wildcardOptional
 * @return {RegInput}
 */
var wildcardToRegExp = function wildcardToRegExp(path, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? "" : _ref$type;
  if (pathCache[type][path] == _reshowConstant.T_NULL) {
    var escReg = type === "bracketsEsc" ? bracketsEscReg : pathEscReg;
    var keys = [];
    var nextPath = (path || "").replace(escReg, "\\$&").replace(/\?/g, "<<?>>").concat("/?").replace(/\/\(/g, "(?:/").replace(/(\/)?(\.)?:(\w+)(?:(\(.*?\)))?(\?)?|\*/g, function (_, slash, format, key, capture, optional) {
      if (_ === "*") {
        keys && keys.push(_reshowConstant.T_UNDEFINED);
        return _;
      }
      keys && keys.push(key);
      slash = slash || "";
      return "" + (optional ? "" : slash) + "(?:" + (optional ? slash : "") + (format || "") + (capture || "([^/]+?)") + ")" + (optional || "");
    }).replace(/\*/g, "(.*)").replace(/<<\?>>/g, ".+");
    var regString = "^" + nextPath + "$";
    var reg = new RegExp(regString, "i");
    pathCache[type][path] = {
      reg: reg,
      keys: keys
    };
  }
  return pathCache[type][path];
};

/**
 * @param {string} testString
 * @param {string} path
 * @param  {wildcardToRegExpOptional} [wildcardOptional]
 * @returns { {[key: string]: any} | boolean }
 */
exports.wildcardToRegExp = wildcardToRegExp;
var wildcardSearch = function wildcardSearch(testString, path, wildcardOptional) {
  var pathToReg = wildcardToRegExp(path, wildcardOptional);
  var o = testString.match(pathToReg.reg);
  if (o && pathToReg.keys.length) {
    var arr = {};
    pathToReg.keys.forEach(function (key, index) {
      if (arr[key]) {
        if (!(0, _reshowConstant.IS_ARRAY)(arr[key])) {
          arr[key] = [arr[key]];
        }
        arr[key].push(o[index + 1]);
      } else {
        arr[key] = o[index + 1];
      }
    });
    return arr;
  } else {
    return o ? true : false;
  }
};
exports.wildcardSearch = wildcardSearch;
var _default = getSafeReg;
exports["default"] = _default;